import script from "./amazon-attribution-service.vue?vue&type=script&setup=true&lang=js"
export * from "./amazon-attribution-service.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__